<template>
  <div class="pb-5 pt-0">
    <loading-spinner v-if="showSpinner" />

    <v-img alt="" contain class="page-header" src="@/assets/redcar/page-headers/whats-on.png" />

    <template v-if="events.length">
      <transition-group name="newEvent" class="items-wrapper events-wrapper">
        <EventItem
          v-for="(event, idx) in events"
          :event="event"
          :eventIdx="idx"
          :key="event.id"
        />
      </transition-group>
    </template>

    <none-found-notice v-if="noEvents" title="No events found" class="items-wrapper"/>
  </div>
</template>

<script>
import EventItem from '@/components/Events/EventItem.vue';
import NoneFoundNotice from '@/components/App/NoneFoundNotice.vue';
import LoadingSpinner from '@/components/App/LoadingSpinner.vue';

import hubbdata from "@/hubbdata";

export default {
  name: 'Events',
  data() {
    return {
      showSpinner: false,
      polling: null,
      isPolling: false
    }
  },
  components: {
    EventItem,
    NoneFoundNotice,
    LoadingSpinner,
  },
  computed: {
    events() {
      return hubbdata.state.events;
    },
    noEvents() {
      return !this.events.length && !this.showSpinner;
    },

  },
  methods: {

  },
  mounted() {
    hubbdata.dispatch("initDB");
  },
  beforeDestroy () {
    clearInterval(this.polling)
  },
};
</script>

<style lang="scss" scoped>
.rotate {
  transform: rotate(45deg);
}

.showForm,
.newEvent {
  &-enter-active,
  &-leave-active {
    transition: opacity 200ms cubic-bezier(0.68, -0.55, 0.265, 1.55), transform 200ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }

  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateY(60px);
  }
}

.events-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media screen and (min-width: 960px) {

  .items-wrapper {
    max-width: 700px;
  }

  .event {
    max-width: 700px !important;
    margin-right: auto !important;
    margin-left: auto !important;
  }
}
</style>
